import React from 'react'
import { Grid, Icon, Popup } from 'semantic-ui-react';
import { Form } from 'formsy-semantic-ui-react';
import Labels from './../../../../common/Labels'
import { dispatch } from '@rematch/core';
import { source } from 'react-aim';

@source({
    mouseEnter: (props, component) => {
        dispatch.app.setHelpContext('Access Control Card');
    }
})
class AccessControl extends React.Component {


    openCategoryModal = (e, type, page) => {
        this.props.handleModalKB(true, type, page)
    }


    render() {

        // this.state.value = this.props.selectedPracticeLibrary.scope;
        const checkAccess = this.props.selectedPracticeLibrary.participants && this.props.selectedPracticeLibrary.participants.length
            && this.props.selectedPracticeLibrary.participants.filter((participant) => { return participant.role === "author" && participant.accountUserId === this.props.user._id });

        const changeScopeAccess = this.props.selectedPracticeLibrary.status === 0 && this.props.selectedOrganisation.role === 'workspaceOwner';
        const changeCategoryAccess = this.props.selectedPracticeLibrary.status === 0 && (checkAccess || this.props.selectedOrganisation.role === 'workspaceOwner')
        return (
            <div >
                <div className="float-left pad_10  w_100" style={{ margin: "0 0 10px 0", background: "white" }}>
                    <div className="float-left w_100" style={{ margin: "0 0 5px 0" }} >
                        <div className="float-left" style={{ fontFamily: "montserrat-semibold", color: "#9e9e9e" }}>Publish level</div>
                        {changeScopeAccess ?
                            <div
                                className="float-right clr-blue cursor-pointer"
                                onClick={(e) => this.openCategoryModal(e, "scope", "playbook")}>
                                {this.props.scope === "Private" ?
                                    this.props.selectedAccount.publicAccess && this.props.selectedOrganisation.role === 'workspaceOwner' ? <span>Change to Public Library</span> : null :
                                    <span>Change to Workspace Library</span>
                                }
                            </div> : null
                        }
                    </div>
                    {this.props.scope === "Private" ?
                        <div className="float-left w_100">
                            <b>Workspace Library</b><br />
                            <p className=" f_11">Playbook will appear under Workspace Library after it is published. All workspace level users can view this playbook.</p>
                        </div> :
                        <div className="float-left w_100">
                            <b>Public Library</b><br />
                            <p className=" f_11">Playbook will appear under Public Library after it is published. All platform users can view this playbook.</p>
                        </div>}
                </div>

                <div className="float-left pad_10  w_100" style={{ margin: "0 0 10px 0", background: "white" }}>
                    <div className="float-left w_100" style={{ margin: "0 0 5px 0" }} >
                        <div className="float-left " style={{ fontFamily: "montserrat-semibold", color: "#9e9e9e" }}>Publish Category</div>
                        {changeCategoryAccess ?
                            <div className="float-right clr-blue cursor-pointer"
                                onClick={(e) => this.openCategoryModal(e, "category", "playbook")}>
                                Change Category
                        </div> : null
                        }
                    </div>
                    <div className="float-left w_100" style={{ margin: "5px 0 5px" }}>
                        <b className="clr-gray f_12">Knowledge Bank</b><br />
                        <b>{this.props.baseCategory && this.props.baseCategory.name !== "" ? this.props.baseCategory.name : "NA"}</b>
                    </div>
                    <div className="float-left w_100" style={{ margin: "5px 0 5px" }}>
                        <b className="clr-gray f_12"> Category</b><br />
                        <b>{this.props.category && this.props.category.name !== "" ? this.props.category.name : "NA"}</b>
                    </div>
                    <div className="float-left w_100" style={{ margin: "5px 0 5px" }}>
                        <b className="clr-gray f_12">Sub Category</b><br />
                        <b>{this.props.subCategory && this.props.subCategory.name !== "" ? this.props.subCategory.name : "NA"}</b>
                    </div>
                </div>

            </div >
        )
    }
}

export default AccessControl